import styled from 'styled-components';

import Image from '@nubank/www-latam-commons/components/Image/Image';

export const ImageBlock = styled(Image)`
  display: block;
`;

ImageBlock.displayName = 'ImageBlock';
